module.exports = __webpack_public_path__ + "img/1523040354.63dffbd5.jpg";